import { render, staticRenderFns } from "./AddDispatchContact.vue?vue&type=template&id=ceac0da2"
import script from "./AddDispatchContact.vue?vue&type=script&lang=js"
export * from "./AddDispatchContact.vue?vue&type=script&lang=js"
import style0 from "./AddDispatchContact.vue?vue&type=style&index=0&id=ceac0da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AddDispatchContact.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports